import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import { api } from "../apiClient.js"

//Importo Menu
import { MenuDesktop } from "./componets/Menu_desktop";
import { MenuMobile } from "./componets/Menu_mobile";
import { MenuNavigazioneMobile } from "./componets/Menu_navigazioneMobile";
import { MenuNavigazioneDesktop } from "./componets/Menu_navigazioneDesktop";

function Dashboard() {
    const navigate = useNavigate();

    //Dichiaro gli State
    const [pazienti, setPazienti] = useState([]);
    const [immagini, setImmagini] = useState(0);
    const [studios, setStudios] = useState([]);
    const [uteneti, setUteneti] = useState([]);

    const menu = [
        {
            id: 1,
            name: "Pazienti",
            imageUrl: `${process.env.REACT_APP_URL_FILESERVER}/medical.svg`,
            lastInvoice: { amount: pazienti.length },
            path: "/pazienti"
        },
        {
            id: 3,
            name: "Studi",
            imageUrl: `${process.env.REACT_APP_URL_FILESERVER}/building.svg`,
            lastInvoice: { amount: studios.length },
            path: "/studio"
        },
        {
            id: 3,
            name: "Gestione Utenti",
            imageUrl: `${process.env.REACT_APP_URL_FILESERVER}/users.svg`,
            lastInvoice: { amount: uteneti.length },
            path: "/utenti"
        },

        {
            id: 2,
            name: "Fotografie",
            imageUrl: `${process.env.REACT_APP_URL_FILESERVER}/image-gallery.svg`,
            lastInvoice: { amount: immagini },
            path: "/presenta"
        },


    ];

    const getAllStudios = async () => {
        try {
            // Configura la richiesta
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `/studio/fetch_all`,
            };

            // Effettua la richiesta con axios
            const response = await api.request(config);

            // Controllo la risposta
            if (response.data.status === true) {
                // Setta lo state con i pazienti
                setStudios(response.data.studios);
            } else {
                // Gestisci il caso in cui la risposta abbia status false
                // console.log("Errore nella risposta:", response.data.message);
                // Potresti anche gestire il caso di errore impostando un messaggio di stato o un alert
            }
        } catch (error) {
            // console.log("Errore nella richiesta:", error);
            // Gestione dell"errore, ad esempio aggiornando lo stato per mostrare un messaggio all"utente
        }
    };

    //Funzione per recuperare tutta la lista degli utenti
    const getAllPazienti = async () => {
        try {
            // Configura la richiesta
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `/patients/fetch_all`,
            };

            // Effettua la richiesta con axios
            const response = await api.request(config);
            // Controllo la risposta
            if (response.data.status === true) {
                // Calcola la somma totale delle immagini di tutti i pazienti
                const imagesLength = response.data.patients.reduce((total, patient) => total + (patient.src_images?.length || 0), 0);
                // Imposta i pazienti nello stato
                setImmagini(imagesLength);
                setPazienti(response.data.patients)

            } else {
                // Gestisci il caso in cui la risposta abbia status false
                // console.log("Errore nella risposta:", response.data.message);
                // Potresti anche gestire il caso di errore impostando un messaggio di stato o un alert
            }
        } catch (error) {
            // Gestione dell"errore, ad esempio aggiornando lo stato per mostrare un messaggio all"utente
        }
    };

    //Funzione per recuperare tutta la lista degli utenti
    const getAllUsers = async () => {
        try {
            // Configura la richiesta
            let config = {
                method: "get",
                maxBodyLength: Infinity,
                url: `/users/fetch_all`,
            };

            // Effettua la richiesta con axios
            const response = await api.request(config);

            // Controllo la risposta
            if (response.data.status === true) {
                // Filtra gli utenti per escludere quelli con ruolo 'system'
                const filteredUsers = response.data.users.filter(
                    (user) => user.role !== "system",
                );
                // Setta lo state con gli utenti filtrati
                setUteneti(filteredUsers);

            } else {
                // Gestisci il caso in cui la risposta abbia status false
                // console.log("Errore nella risposta:", response.data.message);
                // Potresti anche gestire il caso di errore impostando un messaggio di stato o un alert
            }
        } catch (error) {
            // console.log("Errore nella richiesta:", error);
            // Gestione dell'errore, ad esempio aggiornando lo stato per mostrare un messaggio all'utente
        }
    };


    // Recupero le informazioni dai Cookie
    // Esegui il controllo una sola volta quando la pagina viene montata
    useEffect(() => {
        getAllStudios();
        getAllPazienti();
        getAllUsers();
    }, []);

    const GetAnno = () => {
        return new Date().getFullYear();
    };

    return (
        <>
            <div className="flex flex-col min-h-screen bg-gray-100">
                <Disclosure as="nav" className="bg-white shadow-sm">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="flex h-16 justify-between">
                            <div className="flex">
                                <div className="flex flex-shrink-0 items-center">
                                    <img
                                        alt="Your Company"
                                        src="https://fileserver.centrodelsorriso.tribusinformatica.it/logo_top.png"
                                        className="block h-8 w-auto lg:hidden"
                                    />
                                    <img
                                        alt="Your Company"
                                        src="https://fileserver.centrodelsorriso.tribusinformatica.it/logo_top.png"
                                        className="hidden h-8 w-auto lg:block"
                                    />
                                </div>
                                <MenuNavigazioneDesktop
                                    navigate={navigate}
                                />
                            </div>

                            <div className="hidden xl:flex sm:ml-6 sm:items-center">
                                {/* Profile dropdown */}
                                <MenuDesktop />
                            </div>

                            {/* Mobile Section */}
                            <div className="-mr-2 flex items-center xl:hidden">
                                {/* Mobile menu button */}
                                <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                    <span className="absolute -inset-0.5" />
                                    <span className="sr-only">
                                        Open main menu
                                    </span>
                                    <Bars3Icon
                                        aria-hidden="true"
                                        className="block h-6 w-6 group-data-[open]:hidden"
                                    />
                                    <XMarkIcon
                                        aria-hidden="true"
                                        className="hidden h-6 w-6 group-data-[open]:block"
                                    />
                                </DisclosureButton>
                            </div>
                        </div>
                    </div>

                    {/* Mobile  */}
                    <DisclosurePanel className="xl:hidden">
                        <MenuNavigazioneMobile
                            navigate={navigate}
                        />
                        <MenuMobile />
                    </DisclosurePanel>
                </Disclosure>

                <div className="flex-grow py-10 ">
                    <header>
                        <div className="xl:mx-56 md:mx-10 mx-6 max-w-full px-4 sm:px-6 lg:px-8 bg-white shadow sm:rounded-lg p-8">
                            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
                                Dashboard
                            </h1>

                            <div className="mt-2">
                                <div>
                                    <div className="px-4 sm:px-0 "></div>

                                    <ul
                                        role="list"
                                        className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8"
                                    >
                                        {menu.map((item, index) => (
                                            <li
                                                key={index}
                                                className={`overflow-hidden rounded-xl border border-gray-200 ${menu.length - 1 === index ? 'col-span-3' : ''}`}
                                            >
                                                <div className="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-6">
                                                    <img
                                                        alt={item.name}
                                                        src={item.imageUrl}
                                                        className="h-12 w-12 flex-none rounded-lg bg-white object-cover p-1 ring-1 ring-gray-900/10"
                                                    />
                                                    <div className="text-sm font-medium leading-6 text-gray-900">
                                                        {item.name}
                                                    </div>
                                                    <Menu
                                                        as="div"
                                                        className="relative ml-auto"
                                                    >
                                                        <MenuButton className="-m-2.5 block p-2.5 text-gray-400 hover:text-gray-500">
                                                            <span className="sr-only">
                                                                Open options
                                                            </span>
                                                            <EllipsisHorizontalIcon
                                                                aria-hidden="true"
                                                                className="h-5 w-5"
                                                            />
                                                        </MenuButton>
                                                        <MenuItems
                                                            transition
                                                            className="absolute right-0 z-10 mt-0.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                                        >
                                                            <MenuItem>
                                                                <a
                                                                    onClick={() => { navigate(item.path) }}
                                                                    className="block px-3 py-1 text-sm leading-6 text-gray-900 data-[focus]:bg-gray-50"
                                                                >
                                                                    Vedi
                                                                    <span className="sr-only">
                                                                        ,{" "}
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </span>
                                                                </a>
                                                            </MenuItem>
                                                        </MenuItems>
                                                    </Menu>
                                                </div>
                                                <dl className="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
                                                    <div className="flex justify-between gap-x-4 py-3">
                                                        <dd className="flex items-start gap-x-2">
                                                            <div className="font-medium text-gray-900">
                                                                {
                                                                    item
                                                                        .lastInvoice
                                                                        .amount
                                                                }
                                                            </div>
                                                        </dd>
                                                    </div>
                                                </dl>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </header>
                    <main>
                        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
                            {/* Your content */}
                        </div>
                    </main>
                </div>

                <footer className="bg-white">
                    <div className="mx-auto px-6 sm:py-3 md:py-3 xl:py-5 items-center">
                        <div className="mt-4 md:order-1 md:mt-0">
                            <p className="text-center text-xs leading-5 text-gray-500">
                                {GetAnno()} © Centro del Sorriso, sviluppato
                                con il ❤️ da Tribus Informatica Srl
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default Dashboard;
